import { useContext } from "react";
import type { AuthContextType } from "@/features/auth/contexts/auth/context";
import { AuthContext } from "@/features/auth/contexts/auth/context";

export function useAuth(): AuthContextType {
  const auth = useContext(AuthContext);

  if (!auth) {
    throw new Error("useAuth must be used within an AuthProvider");
  }

  return auth;
}
